module.exports = __webpack_public_path__ + "static/media/aquaclinical.2fb414eb.jpg";